import ApiExtension from './api-extension'

export default class Auth extends ApiExtension {
  signInLite(details) {
    return this.fetch(
      'login_lite',
      {},
      { method: 'POST', body: JSON.stringify(details) }
    )
  }

  signIn(details) {
    return this.fetch(
      'login_full',
      {},
      { method: 'POST', body: JSON.stringify(details) }
    )
  }
}
